import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    modal: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      padding: '20px',
      overflow: 'auto',
      '@media (max-width: 768px)': {
        alignItems: 'flex-start',
        padding: '10px',
      },
    },
  }
))
